import { MEDIA_CARD_CLASS } from 'modules/championship/ui/components/form-parts/media/media-tab-layout';
import React from 'react';
import UDEmptyState from 'ud-ui/components/empty-state';

interface MediaTabStateCardProps {
  icon: React.ReactNode;
  /** Строки, а не узлы: типографику заголовка и пояснения `UDEmptyState` даёт только строкам. */
  title: string;
  subtitle: string;
  action?: React.ReactNode;
  'data-testid'?: string;
}

/**
 * Карточка состояния вкладки «Медиа» турнира: иконка, заголовок, пояснение, действия.
 * Одна на «набор не назначен» (IMGM-1491) и «нет тарифа» (IMGM-1510), чтобы два экрана
 * выглядели одинаково: белая карточка на фоне страницы, как у соседних вкладок, внутри —
 * китовый `UDEmptyState`.
 */
const MediaTabStateCard = ({ icon, title, subtitle, action, 'data-testid': testId }: MediaTabStateCardProps) => (
  <section className={`${MEDIA_CARD_CLASS} flex flex-col items-center px-6 py-10`} data-testid={testId}>
    <div className="bg-surfaceSunken rounded-pill text-inkSecondary mb-4 flex h-14 w-14 items-center justify-center" aria-hidden>
      {icon}
    </div>
    <UDEmptyState className="max-w-xl text-center" title={title} subtitle={subtitle} action={action} />
  </section>
);

export default MediaTabStateCard;
